import React from 'react'
import { CONTENT_TYPE } from 'marketing-site/@types/generated/contentful'
import { RichText } from 'marketing-site/src/library/elements/RichText'
import { ResourcesHero } from 'marketing-site/src/components/bespoke/resources/hero/hero'
import { renderTransformedComponent } from 'marketing-site/lib/transformedComponents'
import stylesLegacy from './styles-legacy.scss'
import styles from './styles.scss'
import { IProps } from './index'
import { useBrand } from 'marketing-site/src/library/providers/brandProvider'

export default function BookOrGuidePageContent({ book }: IProps) {
  const brand = useBrand()
  return (
    <>
      <ResourcesHero {...book} />
      {book.fields.details ? (
        <div className="book-guide-page__details">
          <div className="book-guide-page__details-inner">
            <RichText document={book.fields.details} />
          </div>
        </div>
      ) : null}
      {book.fields.bodyContent
        ? book.fields.bodyContent.map((component, index) => (
            <>
              {renderTransformedComponent(
                component.sys.contentType.sys.id as CONTENT_TYPE,
                {
                  ...component,
                },
                index,
                brand,
              )}
            </>
          ))
        : null}
      {brand === 'default' ? <style jsx>{styles}</style> : <style jsx>{stylesLegacy}</style>}
    </>
  )
}
